import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { BootstrapperContext } from "../../../context/bootstrapperContext";
import InputContainer from "../../../ui/layout/page/forms-container/form-item-container/input-container";
import DropdownField from "../../shared/components/formik/dropdown";
import { CompanyModel } from "../types";
import { useFormikContext } from "formik";

export default function IndustrySector({
  dataPath,
  company,
}: {
  dataPath: string;
  company: CompanyModel;
}): React.JSX.Element {
  const { industries } = useContext(BootstrapperContext);
  const { getMessage } = useMessageSource();
  const { setFieldValue } = useFormikContext();

  const isSubBranchPresent = (industryBranchCode: string) => {
    if (!industryBranchCode) {
      return false;
    }

    const matchedIndustry = industries.find((industryBranch) => {
      return industryBranch.code === industryBranchCode;
    });

    return matchedIndustry.subIndustryBranch.length !== 0;
  };

  return (
    <>
      <InputContainer>
        <DropdownField
          name={`${dataPath}industryBranchCode`}
          menuItems={
            industries
              ? industries.map((industry) => {
                  return {
                    value: industry.code,
                    children: industry.name,
                  };
                })
              : []
          }
          onSelectCallback={() =>
            setFieldValue(`${dataPath}industrySubBranchCode`, "")
          }
          selectedItemValue={company.industryBranchCode}
          label={getMessage("Company.industrialBranches")}
        />
      </InputContainer>

      {isSubBranchPresent(company.industryBranchCode) && (
        <InputContainer>
          <DropdownField
            forceReRender
            name={`${dataPath}industrySubBranchCode`}
            menuItems={industries
              .find(
                (industryBranch) =>
                  industryBranch.code === company.industryBranchCode,
              )
              .subIndustryBranch.map((subIndustry) => {
                return {
                  value: subIndustry.code,
                  children: `${subIndustry.code} ${subIndustry.name}`,
                };
              })}
            selectedItemValue={company.industrySubBranchCode}
            label={getMessage("Company.industrialSubBranches")}
          />
        </InputContainer>
      )}
    </>
  );
}
